import { render, staticRenderFns } from "./PanelsContainer.vue?vue&type=template&id=2fc4878e&"
import script from "./PanelsContainer.vue?vue&type=script&lang=js&"
export * from "./PanelsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports